export default {
    breadcrumbs: state => {
        return state.breadcrumbs;
    },
    currentBreadcrumb: state => {
        return state.currentBreadcrumb;
    },

}
